import React from 'react';
import { useCredentials } from '@dentalux/security';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
// import { LocalizationProvider } from '@mui/x-date-pickers'
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

import { ErrorBoundary, ErrorBoundaryLevel } from 'src/components/ErrorBoundary/ErrorBoundary';
import { AnaProvider } from 'src/components/providers/AnaProvider';
import ApolloProvider from 'src/components/providers/ApolloProvider';
import { AuthorizedProvider } from 'src/components/providers/AuthorizedProvider';
import { BookingsProvider } from 'src/components/providers/BookingsProvider';
import { DialogProvider } from 'src/components/providers/DialogProvider';
import { LogoutKindProvider } from 'src/components/providers/LogoutKindProvider';
import PersonIdProvider from 'src/components/providers/PersonIdProvider';
import ReactQueryProvider from 'src/components/providers/ReactQueryProvider';
import { RecommendationProvider } from 'src/components/providers/RecommendationProvider';
import { SnackbarProvider } from 'src/components/providers/SnackbarProvider';
import { UnauthorizedProvider } from 'src/components/providers/UnauthorizedProvider';
// import useDateFnsConfig from 'src/hooks/useDateFnsConfig'
import { ErrorTemplate } from 'src/templates/ErrorTemplate/ErrorTemplate';
import theme from 'src/theme';
const AllProviders = ({
  children
}) => {
  const {
    authentication
  } = useCredentials();

  // const config = useDateFnsConfig()

  const personReferenceId = authentication?.personReferenceId;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(AnaProvider, null, /*#__PURE__*/React.createElement(BookingsProvider, null, /*#__PURE__*/React.createElement(RecommendationProvider, null, /*#__PURE__*/React.createElement(ReactQueryProvider, null, /*#__PURE__*/React.createElement(ApolloProvider, null, /*#__PURE__*/React.createElement(UnauthorizedProvider, null, /*#__PURE__*/React.createElement(CssBaseline, null), /*#__PURE__*/React.createElement(ErrorBoundary, {
    dashboardButton: true,
    Wrapper: ErrorTemplate,
    level: ErrorBoundaryLevel.Generic
  }, /*#__PURE__*/React.createElement(PersonIdProvider, {
    value: personReferenceId
  }, /*#__PURE__*/React.createElement(LogoutKindProvider, null, /*#__PURE__*/React.createElement(AuthorizedProvider, null, /*#__PURE__*/React.createElement(DialogProvider, null, /*#__PURE__*/React.createElement(SnackbarProvider, null, children)))))))))))));
};
export default AllProviders;